// extracted by mini-css-extract-plugin
export default {"list":"webpack-components-core-StructuredList-StructuredList-module__list"};